module.exports = __webpack_public_path__ + "img/gsb31.3aea2f90.png";